/** Direct Meta Instagram DM (Instagram Login, Graph Send) operational issues. */
import type { IssueDefinition } from "../issue-definition";
import { ISSUE_CATEGORY, ISSUE_FAULT } from "../issue-enums";

export const INSTAGRAM_ISSUES = {
  META_INSTAGRAM_AUTH_FAILED: {
    category: ISSUE_CATEGORY.PROVIDER,
    message: "Instagram user access token is invalid or expired",
    severity: "critical",
    fault: ISSUE_FAULT.USER_ACTION,
    userTitle: "Instagram connection invalid",
    userGuidance:
      "Your Instagram connection is invalid or expired, so the agent can't send or receive Instagram messages. Reconnect the account to restore it."
  },
  META_INSTAGRAM_PERMISSION_DENIED: {
    category: ISSUE_CATEGORY.PROVIDER,
    message: "Meta denied permission for the Instagram send request",
    severity: "high",
    fault: ISSUE_FAULT.USER_ACTION,
    userTitle: "Instagram permission denied",
    userGuidance:
      "Meta refused an Instagram send because the app or account lacks the required permission. Reconnect the account and grant messaging access."
  },
  META_INSTAGRAM_RATE_LIMIT: {
    category: ISSUE_CATEGORY.PROVIDER,
    message: "Meta Instagram API rate limit exceeded",
    severity: "medium",
    fault: ISSUE_FAULT.PROVIDER,
    userTitle: "Instagram rate limit reached",
    userGuidance:
      "Meta is rate-limiting Instagram requests. Delivery catches up on its own once the limit clears."
  },
  META_INSTAGRAM_MESSAGE_SEND_FAILED: {
    category: ISSUE_CATEGORY.PROVIDER,
    message: "Meta Instagram message failed to send",
    severity: "high",
    fault: ISSUE_FAULT.PROVIDER,
    userTitle: "Instagram message not delivered",
    userGuidance:
      "An Instagram message could not be delivered due to a Meta Graph API error. It may succeed on retry; persistent failures usually mean the account connection needs attention."
  }
} as const satisfies Record<string, IssueDefinition>;
